import * as React from 'react';
export const banquepopulaireSvg = React.forwardRef(
  function banquepopulaireSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#034EA1',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm5 28.78 11.56-11.56h-1.71L3.29 28.78h-.07V27l11.11-11.111-.848-.848L3.22 25.303v-1.862l10.268-10.268-.848-.849-9.42 9.42v-1.857l7.553-7.553-.849-.849-6.704 6.704V15.84L19.06 0H32v14.72L17.94 28.78h-2.274l11.56-11.56-.849-.849L13.968 28.78h-1.86l12.893-12.892-.849-.849-13.74 13.741H8.543l12.008-12.008-.848-.849L6.847 28.78H5Z',
        fill: '#00ADEE',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M15 11h4v2h-4v4h-2v-4H9v-2h4V7h2v4Zm2.35-4h3.1l1.79 2.62L24.02 7h3.11l-3.33 5 3.4 5h-3.03l-1.93-2.81L20.32 17H17.2l3.69-5-3.54-5Z',
        fill: '#fff',
      }),
    );
  },
);
banquepopulaireSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var banquepopulaire = {
  category: 'brand',
  colorable: false,
  name: 'banquepopulaire',
  svg: banquepopulaireSvg,
};
